import * as React from "react";
import { forwardRef } from "react";
const SvgPrev = (props, ref) => <svg width="1em" height="1em" fill="none" stroke="currentColor" viewBox="0 0 24 24" ref={ref} {...props}><path d="m15 18-6-6 6-6" /></svg>;
const ForwardRef = forwardRef(SvgPrev);
export default ForwardRef;